/**
 * Transform booking parts into a a group of ticket download for activities.
 * 1 group = 1 activity type with ticket downloads for each passenger
 */
export function transformTicketGroupsActivity(bookingParts: ApiBookingPart[], response: ApiSchema['BookingResponse']) {
    const apiBooking = response?.booking;
    if (!apiBooking) {
        return [];
    }

    return bookingParts
        .filter(bp => bp.objectType === 'Activity')
        .reduce<TicketGroupActivity[]>((list, bookingPart) => {
            assignActivity(list, bookingPart, apiBooking);
            return list;
        }, []);
}

/**
 * Assign an activity ticket to the group, if it matches the same activity
 */
function assignActivity(
    list: TicketGroupActivity[],
    activity: ApiSchema['Activity'],
    apiBooking: ApiSchema['Booking'],
) {
    const type = 'Activity';
    const id = activity.activityId ?? '';
    const ticket = transformTicketActivity(activity, apiBooking);
    const key = productConfigs.find(c => c.type === 'Activity' && c.activityId === activity.activityId)?.key;

    let ticketGroup = list
        .filter(p => p.type === type)
        .find(p => p.id === id);
    if (!ticketGroup) {
        ticketGroup = {
            id,
            key,
            type,
            tickets: [],
        } satisfies TicketGroupActivity;
        list.push(ticketGroup);
    }

    ticketGroup.tickets.push(ticket);
}
